import { render, staticRenderFns } from "./loadingPortCode.vue?vue&type=template&id=bbc9490c&"
import script from "./loadingPortCode.vue?vue&type=script&lang=js&"
export * from "./loadingPortCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbc9490c')) {
      api.createRecord('bbc9490c', component.options)
    } else {
      api.reload('bbc9490c', component.options)
    }
    module.hot.accept("./loadingPortCode.vue?vue&type=template&id=bbc9490c&", function () {
      api.rerender('bbc9490c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/se/cargoDoc/loadingPortCode.vue"
export default component.exports